import {
  ClickToPath,
  PackageContent,
  PackageContentPatch,
} from "../Types/types";
import { AppDispatch } from "../components/Manual_List/fetch/store";
import {
  patchLink,
  patchPackageContent,
} from "../components/Manual_List/fetch/slices";

const createStepDataPayload = (
  id: string,
  stepNames: Record<string, string>,
  language: string,
  stepRotation: number,
  stepInitialImagePath: string,
  stepClickToPaths: ClickToPath[],
  stepType: string,
  contentTypes: any,
  stepFile: File | null,
  stepData: any
): PackageContent => {
  return {
    id: parseInt(id),
    label: stepNames[language],
    step: parseInt(id),
    settings: JSON.stringify({
      rotation: stepType === "object" ? stepRotation : undefined,
      initialImagePath:
        stepType === "panorama" ? stepInitialImagePath : undefined,
      clickToPaths: stepType === "panorama" ? stepClickToPaths : undefined,
    }),
    type: stepType as (typeof contentTypes)[number],
    typeId: contentTypes.find((type: any) => type.name === stepType)?.id!,
    source: stepFile,
    links: stepClickToPaths.map((path, index) => ({
      targetPackageContentId: path.path,
      settings: path.angle.toString(),
      id: stepData.links[index]?.id,
    })),
  };
};

const createPackageContentPatchPayload = (
  stepDataPayload: PackageContent,
  stepNames: Record<string, string>
): PackageContentPatch => {
  return {
    id: stepDataPayload.id,
    label: stepNames,
    step: stepDataPayload.step,
    settings: stepDataPayload.settings,
    type: stepDataPayload.type,
    typeId: stepDataPayload.typeId,
    source: stepDataPayload.source,
    links: stepDataPayload.links.map((link) => ({
      targetPackageContentId: parseInt(link.targetPackageContentId),
      settings: link.settings,
    })),
  };
};

const handlePatchPackageContent = async (
  dispatch: AppDispatch,
  stepDataPayload: PackageContent,
  payload: PackageContent
) => {
  await dispatch(
    patchPackageContent({ id: stepDataPayload.id, contentData: payload })
  );
};

const handlePatchLinks = async (
  dispatch: AppDispatch,
  stepClickToPaths: ClickToPath[],
  stepData: any,
  language: string
) => {
  const linkPayload = stepClickToPaths.map((path, index) => {
    const link = stepData.links[index] as { id: any };
    return {
      id: link.id,
      locale: language,
      linkData: {
        targetPackageContentId: path.path,
        settings: path.angle.toString(),
      },
    };
  });

  await Promise.all(
    linkPayload.map((link) =>
      dispatch(
        patchLink({
          id: link.id,
          locale: link.locale,
          linkData: {
            targetPackageContentId: parseInt(
              link.linkData.targetPackageContentId
            ),
            settings: link.linkData.settings,
          },
        })
      )
    )
  );
};

export {
  createStepDataPayload,
  createPackageContentPatchPayload,
  handlePatchPackageContent,
  handlePatchLinks,
};
